import {XauditModel} from '../xaudit.model';

export class AddressDataModel extends XauditModel {
  Address1: string = '';
  Address2: string = '';
  Address3: string = '';
  AddressId: string = '';
  City: string = '';
  ContactId: string = '';
  LOCID: string = '';
  PostCode: string = '';
  State: string = '';
  Suburb: string = '';
  addrDescription: string = '';
  enumAddressCategoryID: string = '';
  enumCountryID: string = '';
  typeDescription: string = '';
  enumStateProvinceID: string;
}
